import { createElement } from '@gn-audio/core/common/templating';
import './basket-ui-message.component.scss';
import template from './basket-ui-message.component.html';
var BasketUIMessageComponent = /** @class */ (function () {
    function BasketUIMessageComponent() {
        var _this = this;
        this.destroy = function () {
            _this.element.classList.remove("visible" /* CssClass.Visible */);
            _this.closeButton.removeEventListener('click', _this.destroy);
            _this.element.remove();
        };
    }
    Object.defineProperty(BasketUIMessageComponent.prototype, "messageId", {
        get: function () {
            return this._messageId;
        },
        enumerable: false,
        configurable: true
    });
    BasketUIMessageComponent.prototype.render = function (options) {
        var _this = this;
        var _a, _b;
        this._messageId = String(Math.random()).slice(2);
        this.element = createElement(template, {
            messageId: this._messageId,
            title: ((_a = options.data) === null || _a === void 0 ? void 0 : _a.title) || options.translations.ExceptionDefaultTitle,
            text: ((_b = options.data) === null || _b === void 0 ? void 0 : _b.text) || options.translations.ExceptionDefaultText,
        }, options.translations);
        options.container.appendChild(this.element);
        setTimeout(function () { _this.element.classList.add("visible" /* CssClass.Visible */); }, 100);
        this.closeButton = this.element.querySelector('.basket-ui-message__button.basket-ui-message__button--close');
        this.closeButton.addEventListener('click', this.destroy);
    };
    return BasketUIMessageComponent;
}());
export { BasketUIMessageComponent };
